import type { Feature, FeatureCollection, LineString, MultiLineString } from 'geojson';
import api from '../lib/api';

export type EtLayers = { powergen: boolean; intrastate: boolean };
export const EMPTY_ET_LAYERS: EtLayers = { powergen: false, intrastate: false };
export const DEFAULT_ET_LAYERS: EtLayers = { powergen: true, intrastate: true };
export const ET_COLORS = { powergen: '#13b9ab', intrastate: '#4d8eef', lateral: '#e9ad59' };
export type EtSourceId = 'powergen' | 'intrastate' | 'customer-map' | 'asset-deck';
export interface EtSource {
  id: EtSourceId; title: string; filename: string; dateLabel: string; sha256: string; note: string;
}
export interface EtSourceRecord {
  sourceId: 'powergen' | 'intrastate'; featureIndex: number; name: string;
  systemOwner: string | null; operator: string | null; product: string | null;
  outsideDiameterRaw: string | null; diameterUnit: null;
}
export interface EtFeatureProperties {
  id: string; label: string; kind: 'pipeline' | 'lateral';
  powergen: boolean; intrastate: boolean; sourceRecordIds: string[]; systemOwner: string | null;
}
export type EtFeature = Feature<LineString | MultiLineString, EtFeatureProperties>;
export interface EtResearchPayload {
  version: string | number;
  reviewedAt: string;
  bounds: [number, number, number, number];
  sources: EtSource[];
  sourceRecords: Record<string, EtSourceRecord>;
  network: FeatureCollection<LineString | MultiLineString, EtFeatureProperties>;
  summary: Record<string, unknown>;
  systems: { id: string; name: string; aliases: string[]; sourceIds: string[]; facts: { text: string; sourceId: string; page?: number }[] }[];
  references: { sourceId: string; title: string; dateLabel: string; sections: { heading: string; text: string[] }[]; links?: { label: string; url: string }[] }[];
  productionComparison: { capturedAt: string; scope: string; summary: string[]; limitations: string[] };
}

export function etFeatureVisible(feature: EtFeature, layers: EtLayers): boolean {
  return (layers.powergen && feature.properties.powergen) || (layers.intrastate && feature.properties.intrastate);
}

export async function fetchEtResearch(signal?: AbortSignal): Promise<EtResearchPayload> {
  const response = await api.get<EtResearchPayload>('/et-research', { signal });
  return response.data;
}
